module.exports = __webpack_public_path__ + "img/faroe-islands.b342373f.svg";